import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { List, ListItem } from 'seagull';
import RecipientDetails from '~/components/RecipientDetails/RecipientDetails';
const MissingSignaturesRecipients = (param)=>{
    let { relationship } = param;
    var _relationship_signatories;
    const { email, lastName, firstName } = relationship.buyer;
    const hasPrimarySignatorySigned = relationship.approvalRecord !== null;
    const recipientDetailsItemStyle = {
        display: 'list-item',
        padding: 0
    };
    return /*#__PURE__*/ _jsxs(List, {
        style: {
            listStyleType: 'disc',
            marginLeft: '22px'
        },
        children: [
            !hasPrimarySignatorySigned && /*#__PURE__*/ _jsx(ListItem, {
                style: recipientDetailsItemStyle,
                children: /*#__PURE__*/ _jsx(RecipientDetails, {
                    testId: "send-proposal-approval-reminder-modal-primary-signatory",
                    companyName: relationship.customer.name,
                    email: email,
                    lastName: lastName,
                    firstName: firstName
                })
            }),
            (_relationship_signatories = relationship.signatories) === null || _relationship_signatories === void 0 ? void 0 : _relationship_signatories.map((signatory, index)=>{
                const hasSignatorySigned = signatory.approvalRecord !== null;
                return !hasSignatorySigned && /*#__PURE__*/ _jsx(ListItem, {
                    style: recipientDetailsItemStyle,
                    children: /*#__PURE__*/ _jsx(RecipientDetails, {
                        testId: "send-proposal-approval-reminder-modal-signatory-".concat(index),
                        email: signatory.email,
                        lastName: signatory.lastName,
                        firstName: signatory.firstName
                    }, signatory.id)
                }, signatory.id);
            })
        ]
    });
};
export default MissingSignaturesRecipients;
